export class BundleListItem {
    bundleId:string;
    session:string;
    name:string;
    comment:string = "";
    finishedEditing:boolean = false;
}